import type { WhatsappTemplatesTranslations } from '../interfaces/whatsappTemplates';

export const whatsappTemplatesTranslations: WhatsappTemplatesTranslations = {
  page_title: 'Plantillas de WhatsApp',
  page_subtitle:
    'Mensajes preaprobados por Meta. Son los únicos que puedes enviar fuera de la ventana de 24 horas.',
  new_template: 'Nueva plantilla',
  sync_from_meta: 'Sincronizar con Meta',
  sync_success: 'Se sincronizaron {{count}} plantillas desde Meta',
  sync_empty: 'No hay plantillas nuevas en Meta',
  search_placeholder: 'Buscar por nombre…',

  column_name: 'Nombre',
  column_category: 'Categoría',
  column_language: 'Idioma',
  column_status: 'Estado',
  column_quality: 'Calidad',
  column_updated: 'Actualizada',
  column_actions: 'Acciones',

  filter_all: 'Todas',
  filter_approved: 'Aprobadas',
  filter_pending: 'En revisión',
  filter_rejected: 'Rechazadas',

  status_APPROVED: 'Aprobada',
  status_IN_APPEAL: 'En apelación',
  status_PENDING: 'En revisión',
  status_PENDING_DELETION: 'Eliminándose',
  status_DELETED: 'Eliminada',
  status_DISABLED: 'Deshabilitada',
  status_LIMIT_EXCEEDED: 'Límite excedido',
  status_REJECTED: 'Rechazada',
  status_PAUSED: 'Pausada',

  category_MARKETING: 'Marketing',
  category_UTILITY: 'Utilidad',
  category_AUTHENTICATION: 'Autenticación',
  category_MARKETING_hint:
    'Promociones, novedades y recuperación de carritos. Requiere que el cliente haya aceptado recibirlas.',
  category_UTILITY_hint:
    'Confirmaciones de pedido, envíos, recordatorios de cita. Es la categoría más fácil de aprobar.',
  category_AUTHENTICATION_hint:
    'Códigos de un solo uso. Meta exige un formato fijo que todavía no soportamos.',

  empty_title: 'Aún no tienes plantillas',
  empty_description:
    'Crea tu primera plantilla o trae las que ya existen en tu cuenta de Meta.',
  empty_action: 'Crear plantilla',
  not_connected_title: 'Conecta WhatsApp primero',
  not_connected_description:
    'Las plantillas viven en tu cuenta de WhatsApp Business. Conéctala para verlas y crearlas desde aquí.',
  not_connected_action: 'Ir a integraciones',
  no_business_id_title: 'Falta información de tu cuenta de Meta',
  no_business_id_description:
    'Tu cuenta se conectó antes de que guardáramos el identificador del portafolio de negocio, que Meta exige para gestionar plantillas. Vuelve a conectar WhatsApp para completarlo.',
  no_business_id_action: 'Volver a conectar',
  rejected_reason_label: 'Motivo del rechazo',

  action_edit: 'Editar',
  action_send: 'Enviar',
  action_duplicate: 'Duplicar',
  action_delete: 'Eliminar',

  delete_title: 'Eliminar plantilla',
  delete_description:
    '¿Seguro que quieres eliminar «{{name}}»? Esta acción no se puede deshacer.',
  delete_all_languages_warning:
    'Meta elimina por nombre: se borrarán todas las versiones de idioma de esta plantilla.',
  delete_confirm: 'Eliminar',
  delete_cancel: 'Cancelar',
  delete_success: 'Plantilla eliminada',

  editor_create_title: 'Nueva plantilla',
  editor_edit_title: 'Editar plantilla',
  editor_save: 'Guardar y enviar a Meta',
  editor_cancel: 'Cancelar',
  editor_create_success: 'Plantilla enviada a revisión de Meta',
  editor_update_success: 'Plantilla actualizada y enviada a revisión',
  editor_readonly_notice:
    'Esta plantilla no se puede editar por su estado actual.',

  section_identity: 'Identidad',
  section_identity_hint:
    'Meta congela estos campos al crear la plantilla; después solo se puede cambiar el contenido.',
  field_name: 'Nombre',
  field_name_hint: 'Solo minúsculas, números y guiones bajos.',
  field_name_preview: 'Se creará como:',
  field_category: 'Categoría',
  field_language: 'Idioma',
  field_parameter_format: 'Formato de variables',
  // `sample` is interpolated at the call site — a literal `{{1}}` here would be
  // eaten by i18next's own interpolation.
  format_positional: 'Numeradas · {{sample}}',
  format_named: 'Con nombre · {{sample}}',
  format_hint: 'No se puede cambiar después de crear la plantilla.',
  identity_locked_notice:
    'Meta no permite cambiar el nombre, la categoría ni el idioma de una plantilla existente.',

  section_header: 'Encabezado',
  section_header_hint: 'Opcional. Una línea corta en negrita sobre el mensaje.',
  header_kind_NONE: 'Sin encabezado',
  header_kind_TEXT: 'Texto',
  header_kind_IMAGE: 'Imagen',
  header_kind_VIDEO: 'Video',
  header_kind_DOCUMENT: 'Documento',
  header_kind_LOCATION: 'Ubicación',
  header_media_unavailable:
    'Los encabezados con multimedia todavía no se pueden crear desde {{brand}}.',
  header_preserved_notice:
    'Esta plantilla usa un encabezado que no se puede editar aquí. Se conservará tal cual al guardar.',
  field_header_text: 'Texto del encabezado',

  section_body: 'Mensaje',
  section_body_hint:
    'El cuerpo del mensaje. Usa variables para personalizarlo por cliente.',
  field_body_text: 'Texto del mensaje',
  add_variable: 'Añadir variable',
  renumber_variables: 'Renumerar variables',
  renumber_hint:
    'Las variables numeradas deben ir de 1 en adelante sin saltos. Meta rechaza la plantilla si falta alguna.',

  section_footer: 'Pie de página',
  section_footer_hint: 'Opcional. Texto pequeño y gris bajo el mensaje.',
  footer_enable: 'Añadir pie de página',
  field_footer_text: 'Texto del pie',

  section_buttons: 'Botones',
  section_buttons_hint: 'Opcional. Hasta 3 botones.',
  add_button: 'Añadir botón',
  button_type_QUICK_REPLY: 'Respuesta rápida',
  button_type_URL: 'Abrir enlace',
  button_type_PHONE_NUMBER: 'Llamar',
  field_button_text: 'Texto del botón',
  field_button_url: 'Enlace',
  field_button_phone: 'Teléfono',
  button_move_up: 'Subir',
  button_move_down: 'Bajar',
  button_remove: 'Quitar botón',

  section_variables: 'Ejemplos de variables',
  variables_required_notice:
    'Meta rechaza las plantillas cuyas variables no tienen un valor de ejemplo. Se usan solo para la revisión, no se envían a tus clientes.',
  variables_empty:
    'Este mensaje no tiene variables. Escribe {{sample}} en el texto para añadir una.',
  field_example_value: 'Valor de ejemplo',
  variable_label: 'Variable',

  preview_title: 'Vista previa',
  preview_empty: 'Escribe el mensaje para ver la vista previa.',

  confirm_edit_title: 'Editar una plantilla aprobada',
  confirm_edit_description:
    'Al guardar, esta plantilla vuelve a revisión de Meta y no se podrá enviar hasta que la aprueben otra vez.',
  confirm_edit_accept: 'Entiendo, guardar',
  confirm_edit_cancel: 'Cancelar',

  validation_name_required: 'Escribe un nombre',
  validation_name_format: 'Solo minúsculas, números y guiones bajos',
  validation_name_hex24:
    'Este nombre choca con el formato de identificador interno. Añade o quita un carácter.',
  validation_name_duplicate: 'Ya tienes una plantilla con este nombre e idioma',
  validation_body_required: 'El mensaje no puede estar vacío',
  validation_body_max: 'Máximo 1024 caracteres',
  validation_footer_max: 'Máximo 60 caracteres',
  validation_header_max: 'Máximo 60 caracteres',
  validation_example_required: 'Meta exige un ejemplo para cada variable',
  validation_positional_gap:
    'Las variables deben ir de 1 en adelante sin saltos',
  validation_named_format:
    'Las variables con nombre deben empezar por una letra minúscula y usar solo letras, números y guiones bajos',
  validation_edge_variable:
    'El mensaje no puede empezar ni terminar con una variable',
  validation_adjacent_variables: 'Dos variables no pueden ir seguidas',
  validation_footer_no_variables: 'El pie de página no admite variables',
  validation_header_one_variable: 'El encabezado admite como máximo una variable',
  validation_button_text_required: 'Escribe el texto del botón',
  validation_button_url: 'Escribe un enlace válido',
  validation_button_phone: 'Escribe un teléfono en formato internacional',
  validation_buttons_max: 'Máximo 3 botones',
  validation_url_buttons_max: 'Máximo 2 botones de enlace',
  validation_phone_buttons_max: 'Máximo 1 botón de llamada',
  validation_wrong_format_tokens:
    'Esta plantilla usa variables {{format}}. Usa ese formato o Meta no las detectará.',

  send_title: 'Enviar plantilla',
  send_description:
    'Se envía desde tu número de WhatsApp Business y llega al chat del cliente.',
  send_template_label: 'Plantilla',
  send_template_placeholder: 'Elige una plantilla aprobada',
  send_from_label: 'Enviar desde',
  send_to_label: 'Enviar a',
  send_to_placeholder: '+57 319 684 4292',
  send_to_invalid: 'Incluye el indicativo del país, por ejemplo +57 319 684 4292',
  send_fill_examples: 'Rellenar con los ejemplos',
  send_submit: 'Enviar',
  send_cancel: 'Cancelar',
  send_success: 'Mensaje enviado',
  send_no_approved_title: 'No tienes plantillas aprobadas',
  send_no_approved_description:
    'Solo se pueden enviar plantillas que Meta ya aprobó.',
  send_no_approved_action: 'Ver plantillas',
  send_media_link_label: 'Enlace del archivo',
  send_media_link_hint:
    'Esta plantilla lleva multimedia en el encabezado. Pega un enlace público al archivo.',
  send_variables_title: 'Variables',

  error_UNAUTHORIZED: 'Tu sesión expiró. Vuelve a entrar.',
  error_FORBIDDEN:
    'Tu rol no tiene permisos sobre plantillas de WhatsApp. Pídeselos a un administrador.',
  error_NOT_FOUND: 'No encontramos la plantilla',
  error_VALIDATION: 'Meta rechazó los datos: {{detail}}',
  error_NO_WABA_TOKEN:
    'Tu organización aún no tiene WhatsApp conectado. Conéctalo en Ajustes → Integraciones.',
  error_TEMPLATE_EXISTS: 'Ya existe una plantilla con ese nombre e idioma',
  error_META_REJECTED: 'Meta rechazó la solicitud: {{detail}}',
  error_UNKNOWN: 'Algo salió mal: {{detail}}',
};
